import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const orderLinesSectionK = {
  getBCPayload: "order_lines_section.getBCPayload",
  salesPrice: "order_lines_section.salesPrice",
  productNumber: "order_lines_section.productNumber",
  noProducts: "order_lines_section.noProducts",
  quantity: "order_lines_section.quantity",
  unitOfMeasure: "order_lines_section.unitOfMeasure",
  partsOfTheConfiguration: "order_lines_section.partsOfTheConfiguration",
  currency: "order_lines_section.currency",
  noProductsToOrderPleaseConfigure: "order_lines_section.noProductsToOrderPleaseConfigure",
  productionPrice: "order_lines_section.productionPrice",
  product: "order_lines_section.product",
  unitPrice: "order_lines_section.unitPrice",
};

export const useOrderLinesSectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      getBCPayload: t(orderLinesSectionK.getBCPayload),
      salesPrice: t(orderLinesSectionK.salesPrice),
      productNumber: t(orderLinesSectionK.productNumber),
      noProducts: t(orderLinesSectionK.noProducts),
      quantity: t(orderLinesSectionK.quantity),
      unitOfMeasure: t(orderLinesSectionK.unitOfMeasure),
      partsOfTheConfiguration: t(orderLinesSectionK.partsOfTheConfiguration),
      currency: t(orderLinesSectionK.currency),
      noProductsToOrderPleaseConfigure: t(orderLinesSectionK.noProductsToOrderPleaseConfigure),
      productionPrice: t(orderLinesSectionK.productionPrice),
      product: t(orderLinesSectionK.product),
      unitPrice: t(orderLinesSectionK.unitPrice),
    }),
    [i18n.language]
  );
};